export default __webpack_public_path__ + "images/8P.e8813be.png";